import TbbRegisteredDialog from './TbbRegisteredDialog';

export default TbbRegisteredDialog;
